import { yieldMainThread } from "@devowl-wp/react-utils";
import { getCookieConsentManager } from "./getCookieConsentManager.js";
/**
 * Save consent to the backend and apply cookies on running session.
 */ const persistConsent = async (param)=>{
    let { consent, gcmConsent, markAsDoNotTrack = false, buttonClicked, blocker = 0, blockerThumbnail, tcfString, recorderJsonString, uiView } = param;
    const { clientWidth, clientHeight } = document.documentElement;
    let awaitedTcfString;
    if (tcfString) {
        awaitedTcfString = tcfString();
        await yieldMainThread();
    }
    await getCookieConsentManager().persistConsent({
        decision: consent,
        gcmConsent,
        markAsDoNotTrack,
        buttonClicked,
        viewPortWidth: clientWidth,
        viewPortHeight: clientHeight,
        blocker,
        blockerThumbnail,
        tcfString: awaitedTcfString,
        recorderJsonString,
        uiView
    });
};
export { persistConsent };
